/* eslint-disable @typescript-eslint/no-explicit-any */
import { StatusListItemText } from './StatusListItemText';
import * as MuiCore from '@mui/material';
import * as React from 'react';
import * as Styles from './styles';
import clsx from 'clsx';

const StatusList: React.FC<{
    items: Array<{
        label: string;
        bold?: boolean;
        icon: React.ElementType;
        className?: string;
    }>;
}> = (props) => {
    const classes = Styles.useStyles();

    return (
        <MuiCore.List dense>
            {(props.items || []).map((listItem, index) => {
                const className = listItem.className
                    ? clsx({ [classes[listItem.className as keyof typeof classes]]: listItem.bold })
                    : undefined;

                return (
                    <MuiCore.ListItem key={index} style={{ backgroundColor: 'transparent' }}>
                        <MuiCore.ListItemIcon>
                            <listItem.icon className={className} data-testid={`${listItem.label}-icon`} />
                        </MuiCore.ListItemIcon>
                        <MuiCore.ListItemText
                            className={className}
                            primary={<StatusListItemText status={listItem.label} bold={listItem.bold || false} />}
                        />
                    </MuiCore.ListItem>
                );
            })}
        </MuiCore.List>
    );
};

export { StatusList };
